export function validateTextField(text, minChar) {
  if (!text || typeof text !== 'string') {
    return false;
  }
  return minChar > 0 ? text.length >= minChar : true;
}

export function hideMessageElement(element) {
  if (element) {
    element.classList.add('hidden');
  }
}

export function showMessageElement(element, message) {
  if (element) {
    element.textContent = message;
    element.classList.remove('hidden');
  }
}

export function disableSubmitButton(button) {
  if (button) {
    button.disabled = true;
  }
}

export function enableSubmitButton(button) {
  if (button) {
    button.disabled = false;
  }
}

export function disableInputFields(inputFields) {
  if (inputFields) {
    inputFields.forEach((input) => (input.disabled = true));
  }
}

export function enableInputFields(inputFields) {
  if (inputFields) {
    inputFields.forEach((input) => (input.disabled = false));
  }
}

export function resetForm(container) {
  const inputFields = container.querySelectorAll('.text-field input');
  if (inputFields) {
    inputFields.forEach((input) => (input.value = ''));
  }
}

export function showLoader(container) {
  const loader = container.querySelector('.loader');
  if (loader) {
    loader.classList.remove('hidden');
  }
}

export function hideLoader(container) {
  const loader = container.querySelector('.loader');
  if (loader) {
    loader.classList.add('hidden');
  }
}

export function saveToLocalStorage(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getFromLocalStorage(key) {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : null;
}